import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class UserTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // User icon position (top-left corner)
    const ix = x - width / 2 + 8;
    const iy = y - height / 2 + 6;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN User icon (head + shoulders)
      h('circle', { cx: ix + 6, cy: iy + 4, r: 3.5, fill: 'none', stroke: style.stroke, strokeWidth: 1.2 }),
      h('path', {
        d: `M ${ix + 1} ${iy + 13} Q ${ix + 6} ${iy + 8} ${ix + 11} ${iy + 13}`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
    ];


    // Wrapped text inside the shape
    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    // Loop / Multi-Instance markers
    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class UserTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'userTask');
    style.stroke = t.stroke || '#1890ff';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#e6f7ff';
    return style;
  }
}

export const UserTask = {
  type: 'epx:UserTask',
  view: UserTaskView,
  model: UserTaskModel,
};
